var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademixLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.7,96.9c-12.3-12.3-32.3-12.3-44.6,0L28.5,370.6c-12.3,12.3-12.3,32.3,0,44.6,6.2,6.1,14.2,9.2,22.3,9.2s16.1-3.1,22.3-9.2L346.8,141.5c12.2-12.4,12.2-32.3-.1-44.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.8,324.4l46.1-46.1c12.3-12.3,12.3-32.3,0-44.6s-32.3-12.3-44.6,0l-46.1,46.1-23.8-23.8,46.1-46.1c12.3-12.3,12.3-32.3,0-44.6s-32.3-12.3-44.6,0l-205.2,205.3c-12.3,12.3-12.3,32.3,0,44.6,6.1,6.1,14.2,9.2,22.3,9.2s16.1-3.1,22.3-9.2l114.6-114.6,23.9,23.9-46.1,46.1c-12.3,12.3-12.3,32.3,0,44.6,6.1,6.1,14.2,9.2,22.3,9.2s16.1-3.1,22.3-9.2l46.1-46.1,46.1,46.1c6.1,6.1,14.2,9.2,22.3,9.2s16.1-3.1,22.3-9.2c12.3-12.3,12.3-32.3,0-44.6l-46.3-46.2h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 461.3,
    cy: 119.1,
    r: 31.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademixLogoWhite);
export default __webpack_public_path__ + "static/media/academix-logo-white.39c11c52c585dc8cfc7fc3dfe9d5d84b.svg";
export { ForwardRef as ReactComponent };